






























import HeadingButtons from "@/components/HeadingButtons.vue";
import BarChart from "@/components/BarChart.vue";
import { Stats } from "@/types/stats";
import { BarChartValues } from "@/types/bar-chart";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({
  components: {
    HeadingButtons,
    BarChart,
  },
})
export default class OverviewStats extends Vue {
  @State(state => state.stats.stats) stats!: Stats;

  get rows(): BarChartValues[] {
    const types = ["get", "delete", "incr", "decr", "cas", "touch"];

    const rows: BarChartValues[] = [];
    for (const type of types) {
      const values: BarChartValues = {
        a: { label: `${type} hits`, value: this.stats[`${type}_hits`] },
        b: { label: `${type} misses`, value: this.stats[`${type}_misses`] },
      };
      rows.push(values);
    }

    return rows;
  }
}
